import {GET_VENDOR_PO_DETAILS,GET_VENDOR_PO_DETAILS_ERROR,
        POST_REQUEST_INSPECTION,POST_REQUEST_INSPECTION_ERROR,
        GET_SUPPLIER_POS_WITH_STAGES,
        GET_SUPPLIER_POS_WITH_STAGES_ERROR,GET_PO_SEARCH_BY_VENDOR,GET_PO_SEARCH_BY_VENDOR_ERROR,
        GET_ALL_SUPPLIERS, GET_ALL_SUPPLIERS_ERROR,
        GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER,GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER_ERROR,
        GET_ALL_PO_UPLOADED_FOR_DS,GET_ALL_PO_UPLOADED_FOR_DS_ERROR,
        GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE, GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE_ERROR
    } from '../type'
import axios from 'axios';
import env from '../../ENV';
import swal from '@sweetalert/with-react';
let ROOT_URL = env.BACKEND_URL;

export const getVendorPODetails = (id) => async dispatch => {
    
    try{
        const res = await axios.post(`${ROOT_URL}vendor/${id}/po`)
        dispatch( {
            type: GET_VENDOR_PO_DETAILS,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_VENDOR_PO_DETAILS_ERROR,
            payload: console.log(e),
        })
    }

}

export const getVendorPODetailsWithStages = (id) => async dispatch => {
    
    try{
        const res = await axios.get(`${ROOT_URL}vendor/${id}/po/stages`)
        dispatch( {
            type: GET_SUPPLIER_POS_WITH_STAGES,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_SUPPLIER_POS_WITH_STAGES_ERROR,
            payload: console.log(e),
        })
    }

}

export const postRequestInspection = (id, data) => async dispatch => {
    
    console.log("recieved in store ", id, data)
    try{
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}vendor/${id}/inspection`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: POST_REQUEST_INSPECTION,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: POST_REQUEST_INSPECTION_ERROR,
            payload: console.log(e),
        })
    }

}

export const posNewtRequestInspection = (param) => async dispatch => {
    
    try{
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}vendor/request-inspection`,
            data: param,
            headers: {
                'content-type': 'application/json',
            }
        })
        swal("Requested has been saved",{icon:"success"})
        dispatch( {
            type: POST_REQUEST_INSPECTION,
            payload: res.data
        })
    }
    catch(e){
        console.log("Error",e.response);
        let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        swal(message,{icon:"error"});
        dispatch( {
            type: POST_REQUEST_INSPECTION_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetPOSearchByVendor = (input) => async dispatch => {
    
    console.log("recieved in store ", input)
    try{
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}vendor/po`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: GET_PO_SEARCH_BY_VENDOR,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_PO_SEARCH_BY_VENDOR_ERROR,
            payload: console.log(e),
        })
    }

}

export const getAllSuppliers = () => async dispatch => {
    try{
        const res = await axios.get(`${ROOT_URL}vendor/all`);
        dispatch( {
            type: GET_ALL_SUPPLIERS,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_ALL_SUPPLIERS_ERROR,
            payload: console.log(e),
        })
    }
}


export const GetAllPoAcceptanceDetailForSupplier = (userid,SearchTerm,isExpeditor) => async dispatch => {
    try{
        const res = await axios.get(`${ROOT_URL}expediting/poacceptancedetail/${userid}/${SearchTerm}/${isExpeditor}`);
        dispatch( {
            type: GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER_ERROR,
            payload: console.log(e),
        })
    }
}


export const GetAllDetailsOfPoUploadedForDS = (userid) => async dispatch => {
    try{
        const res = await axios.get(`${ROOT_URL}expediting/pouploadfor-ds/${userid}`);
        dispatch( {
            type: GET_ALL_PO_UPLOADED_FOR_DS,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_ALL_PO_UPLOADED_FOR_DS_ERROR,
            payload: console.log(e),
        })
    }
}

export const getVendorPODetailsForPOAcceptance = (id) => async dispatch => {
    
    try{
        const res = await axios.post(`${ROOT_URL}vendor-poDetails-for-POAcceptance/${id}/po`)
        dispatch( {
            type: GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE_ERROR,
            payload: console.log(e),
        })
    }
}